/* eslint-disable react-hooks/exhaustive-deps */
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {KTIcon, toAbsoluteUrl} from '../../../helpers'
import {useLayout} from '../../core'
import {Header} from './Header'
import {Navbar} from './Navbar'
import {app_id} from '../../../../app/modules/config'
import Logo from '../../../../app/utils/components/Logo'
import {isReddata} from '../../../../app/utils/helperFunction/_helper'
import KeyContactDetails from './KeyContactDetails'

export function HeaderWrapper() {
  const {config, classes} = useLayout()
  if (!config.app?.header?.display) {
    return null
  }

  const homePath = '/analyze/dashboard'
  const pathurl = isReddata() ? '/media/logos/reddata-icon-logo.png' : '/media/logos/iatl-logo.png'

  return (
    <div id='kt_app_header' className='app-header shadow-sm bg-light'>
      <div
        id='kt_app_header_container'
        className={clsx(
          'px-8 flex-lg-grow-1 w-100',
          classes.headerContainer.join(' '),
          config.app?.header?.default?.containerClass
        )}
        style={{width: '100%'}}
      >
        {config.app.sidebar?.display && (
          <>
            <div
              className='d-flex align-items-center d-lg-none ms-n2 me-2'
              title='Show sidebar menu'
            >
              <div
                className='btn btn-icon btn-active-color-primary w-35px h-35px'
                data-kt-drawer-toggle='true'
                id='kt_app_sidebar_mobile_toggle'
                data-kt-drawer-target='#kt_app_sidebar'
              >
                <KTIcon iconName='abstract-14' className=' fs-1' />
              </div>
              <div className='d-flex align-items-center flex-grow-1 flex-lg-grow-0'>
                <Link to={homePath} className='d-lg-none'>
                  <Logo classname='h-25px' path={pathurl} />
                </Link>
              </div>
            </div>
          </>
        )}

        {!(config.layoutType === 'dark-sidebar' || config.layoutType === 'light-sidebar') && (
          <div className='d-flex align-items-center flex-grow-1 flex-lg-grow-0 me-lg-15'>
            <Link to={homePath}>
              {config.layoutType !== 'dark-header' ? (
                <Logo classname='h-20px h-lg-30px app-sidebar-logo-default' />
              ) : (
                <>
                  <Logo classname='h-20px h-lg-30px app-sidebar-logo-default theme-light-show' />
                  <Logo classname='h-20px h-lg-30px app-sidebar-logo-default theme-dark-show' />
                </>
              )}
            </Link>
          </div>
        )}
        {app_id === 0 && <KeyContactDetails />}

        {/* TODO: Stop showing twice */}
        <div
          id='kt_app_header_wrapper'
          className='d-flex align-items-stretch justify-content-between flex-lg-grow-1'
        >
          {config.app.header.default?.content === 'menu' &&
            config.app.header.default.menu?.display && (
              <div
                className='app-header-menu app-header-mobile-drawer align-items-stretch'
                data-kt-drawer='true'
                data-kt-drawer-name='app-header-menu'
                data-kt-drawer-activate='{default: true, lg: false}'
                data-kt-drawer-overlay='true'
                data-kt-drawer-width='225px'
                data-kt-drawer-direction='end'
                data-kt-drawer-toggle='#kt_app_header_menu_toggle'
                data-kt-swapper='true'
                data-kt-swapper-mode="{default: 'append', lg: 'prepend'}"
                data-kt-swapper-parent="{default: '#kt_app_body', lg: '#kt_app_header_wrapper'}"
              >
                <Header />
              </div>
            )}

          <Navbar />
        </div>
      </div>
    </div>
  )
}
